"use client";
import { Typography } from "antd";
import Image from "next/image";
import React, { useState } from "react";
import { Mousewheel, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { bestChoiceContents } from "./bestChoiceContents";

const ACTIVE_SLIDE_SCALE = 1.2;
const NEARBY_SLIDE_SCALE = 1.1;
const SLIDE_Z_INDEX_BASE = 30;
const SLIDE_BASE_Y_PX = 40;
const SLIDE_Y_STEP_PX = 6;

const BestChoiceSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { Title } = Typography;

  return (
    <div className="relative w-full h-[30rem] flex items-center justify-center">
      <Swiper
        slidesPerView={5}
        spaceBetween={-80}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        centeredSlides={true}
        modules={[Pagination, Mousewheel]}
        pagination={{
          clickable: true,
        }}
        initialSlide={Math.floor(bestChoiceContents.length / 2)}
        className="h-full !pe-14 !ps-[1.4rem] xs:!pe-16 xs:!ps-12 xs:max-w-[31rem] sm:!ps-16 sm:!pe-24 sm:max-w-[35rem] md:!pe-30 md:!ps-18 md:max-w-[40rem] lg:!pe-46 lg:!ps-32 lg:max-w-[55rem] xl:!pe-36 xl:!ps-32 2xl:!pe-42 2xl:!ps-32 bestChoiceSlider"
        style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          width: "100%",
        }}
        dir="rtl"
      >
        {bestChoiceContents.map((item, index) => {
          const offset = index - activeIndex;
          const distance = Math.abs(offset);

          let scale = 0.8;
          if (distance === 0) scale = ACTIVE_SLIDE_SCALE;
          else if (distance === 1) scale = NEARBY_SLIDE_SCALE;
          else if (distance === 2) scale = 1;

          const zIndex = SLIDE_Z_INDEX_BASE - distance;
          const translateY = SLIDE_BASE_Y_PX - distance * SLIDE_Y_STEP_PX;

          return (
            <SwiperSlide
              key={item.id}
              className="transition-all duration-300 flex justify-center items-center"
              style={{
                zIndex,
                transform: `scale(${scale}) translateY(${translateY}px)`,
                transformOrigin: "center center",
              }}
            >
              <div className="bg-white rounded-lg shadow-multiShadow border-[0.063rem] border-regal-gray-light p-4 flex flex-col gap-2 items-center text-center w-[150px] sm:w-[180px] md:w-[220px] lg:w-[250px]">
                <Title
                  level={3}
                  className="H3 !text-xs sm:!text-sm xl:!text-base !text-primary h-10 xl:h-15 flex items-center justify-center"
                >
                  {item.title}
                </Title>
                <Image
                  width={100}
                  height={100}
                  alt={item.title}
                  src={item.url}
                  className="rounded-lg w-full"
                />
                <div className="flex justify-center h-8">
                  <p className="!text-[0.5rem] sm:!text-tiny xl:!text-xs text-center">
                    {item.description}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default BestChoiceSlider;
